import React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

import SignInPage from '../SignIn';
import SignUpPage from '../SignUp';
import DepositeConfirmation from '../DepositeConfirmation';

function AuthRoutes() {
    return (
        <Router>
            <Switch>
                <Route exact path={ROUTES.INDEX} component={SignInPage} />
                <Route exact path={ROUTES.SIGN_IN} component={SignInPage} />
            </Switch>
            <div className="content-inner-section-auth">
                <Switch>
                    <Route exact path={ROUTES.SignUp} component={SignUpPage} />
                    <Route
                        exact
                        path={ROUTES.DepositeConfirmation}
                        component={DepositeConfirmation}
                    />
                    <Route
                        exact
                        path={ROUTES.DepositeConfirmationOLD}
                        component={DepositeConfirmation}
                    />
                </Switch>
            </div>
        </Router>
    );
}

export default AuthRoutes;
